import { Component, OnInit } from '@angular/core';
// Activated Route
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/services.index';

import * as XLSX from 'xlsx';

@Component({
  selector: 'app-reporte-ganancias',
  templateUrl: './reporte-ganancias.component.html',
  styles: []
})
export class ReporteGananciasComponent implements OnInit {

  gananciasPorCategArg: any[] = [];
  gananciasPorCategUsd: any[] = [];

  gananciasPorActivArg: any[] = [];
  gananciasPorActivUsd: any[] = [];

  loading: boolean = false;

  congreso_id: string;

  constructor(private activatedRoute: ActivatedRoute,
              public _userService: UserService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe( params => {
      let congresoId: any = params['congreso'];
      this.congreso_id = congresoId;
      let promises: any[] = [];
      this.loading = true;
      promises.push(
        new Promise((resolve, reject) => {
          this._userService.getGananciasPorCategArg(congresoId).subscribe(resp => {
            this.gananciasPorCategArg = resp;
            resolve();
          });
        })
      );
      promises.push(
        new Promise((resolve, reject) => {
          this._userService.getGananciasPorCategUsd(congresoId).subscribe(resp => {
            this.gananciasPorCategUsd = resp;
            resolve();
          });
        })
      );
      promises.push(
        new Promise((resolve, reject) => {
          this._userService.getGananciasPorActivArg(congresoId).subscribe(resp => {
            this.gananciasPorActivArg = resp;
            resolve();
          });
        })
      );
      promises.push(
        new Promise((resolve, reject) => {
          this._userService.getGananciasPorActivUsd(congresoId).subscribe(resp => {
            this.gananciasPorActivUsd = resp;
            resolve();
          });
        })
      );
      Promise.all(promises).then(resp => {
        this.loading = false;
      });
    });
  }

  sumaTotal(array: any[]) {
    let sum: number = 0;
    for (let element of array) {
      sum = sum + element.balance;
    }
    return sum;
  }

  sumaTotalCount(array: any[]) {
    let sum: number = 0;
    for (let element of array) {
      sum = sum + element.count;
    }
    return sum;
  }

  generateExcel() {
    this.loading = true;

    let listadoImprimir: any[] = [];

    let tituloListado1: string;
    let tituloListado2: string;
    let gananciasImprimir: any[];

    // CATEGORIAS

    tituloListado1 = 'Ganancias por Categoría de Inscripción: ';
    tituloListado2 = 'Nacionales: ';

    gananciasImprimir = this.gananciasPorCategArg;

    listadoImprimir.push([tituloListado1]);
    listadoImprimir.push([tituloListado2]);

    listadoImprimir.push(['Categoría', 'Cant. Inscriptos', 'Ganancias']);

    for (let categoria of gananciasImprimir) {
      let arrInscripto: any[] = [];
      arrInscripto = [categoria._id.nombre_es, categoria.count, categoria.balance];

      listadoImprimir.push(arrInscripto);
    }

    listadoImprimir.push(['TOTAL', this.sumaTotalCount(this.gananciasPorCategArg), this.sumaTotal(this.gananciasPorCategArg)]);

    listadoImprimir.push([' ', ' ', ' ']);

    tituloListado2 = 'Extranjeros: ';

    gananciasImprimir = this.gananciasPorCategUsd;

    listadoImprimir.push([tituloListado2]);

    listadoImprimir.push(['Categoría', 'Cant. Inscriptos', 'Ganancias']);

    for (let categoria of gananciasImprimir) {
      let arrInscripto: any[] = [];
      arrInscripto = [categoria._id.nombre_es, categoria.count, categoria.balance];

      listadoImprimir.push(arrInscripto);
    }

    listadoImprimir.push(['TOTAL', this.sumaTotalCount(this.gananciasPorCategUsd), this.sumaTotal(this.gananciasPorCategUsd)]);

    listadoImprimir.push([' ', ' ', ' ']);
    listadoImprimir.push([' ', ' ', ' ']);

    // ACTIVIDADES

    tituloListado1 = 'Ganancias por Actividad de Inscripción: ';
    tituloListado2 = 'Nacionales: ';

    gananciasImprimir = this.gananciasPorActivArg;

    listadoImprimir.push([tituloListado1]);
    listadoImprimir.push([tituloListado2]);

    listadoImprimir.push(['Actividad', 'Cant. Inscriptos', 'Ganancias']);

    for (let categoria of gananciasImprimir) {
      let arrInscripto: any[] = [];
      arrInscripto = [categoria._id.nombre_es, categoria.count, categoria.balance];

      listadoImprimir.push(arrInscripto);
    }

    listadoImprimir.push(['TOTAL', this.sumaTotalCount(this.gananciasPorActivArg), this.sumaTotal(this.gananciasPorActivArg)]);

    listadoImprimir.push([' ', ' ', ' ']);

    tituloListado2 = 'Extranjeros: ';

    gananciasImprimir = this.gananciasPorActivUsd;

    listadoImprimir.push([tituloListado2]);

    listadoImprimir.push(['Actividad', 'Cant. Inscriptos', 'Ganancias']);

    for (let categoria of gananciasImprimir) {
      let arrInscripto: any[] = [];
      arrInscripto = [categoria._id.nombre_es, categoria.count, categoria.balance];

      listadoImprimir.push(arrInscripto);
    }

    listadoImprimir.push(['TOTAL', this.sumaTotalCount(this.gananciasPorActivUsd), this.sumaTotal(this.gananciasPorActivUsd)]);

    this.excelMethods(listadoImprimir);
  }

  excelMethods(listadoImprimir: any) {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(listadoImprimir);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inscriptos');

    /* save to file */
    XLSX.writeFile(wb, 'reporte-ganancias.xlsx');
    this.loading = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/reporte-ganancias/reporte-ganancias.component.ts